// #IMPORTANT: we are not using the examples, the examples are just for reference
// #IMPORTANT: the keys are not used in the code, they are only for reference
const DOCUMENT_CATEGORIES = {
  IDENTIFICATION: "identification",
  EMPLOYMENT_STATUS: "employment_status",
  INCOME: "income",
  TAX: "tax",
  EDUCATION: "education",
  BUSINESS: "business",
  RESIDENCY_HOUSING: "residency_housing",
  FAMILY_LEGAL: "family_legal",
  BENEFITS_PENSION: "benefits_pension",
  PAYMENT_RECEIPT: "payment_receipt",
  FINANCIAL: "financial",
  MEDICAL_DISABILITY: "medical_disability",
  OTHER: "other",
};

const DOCUMENT_CATEGORY_CONFIG = {
  [DOCUMENT_CATEGORIES.IDENTIFICATION]: [
    "Passport",
    "DNI/NIE",
    "National identity card",
    "Residence permit card",
    "Other identity document",
  ],

  [DOCUMENT_CATEGORIES.EMPLOYMENT_STATUS]: [
    "Employment contract",
    "Working life certificate",
    "Appointment notice",
    "Social security employment/status documents",
  ],

  [DOCUMENT_CATEGORIES.INCOME]: [
    "Payslip",
    "Retroactive payslip",
    "Bonus receipt",
    "Wage statement",
    "Annual payment certificate",
    "Income proof",
  ],

  [DOCUMENT_CATEGORIES.TAX]: [
    "Personal tax returns",
    "VAT tax reports",
    "Fractionated tax reports",
    "Corporate tax returns",
    "W-2 tax statements",
  ],

  [DOCUMENT_CATEGORIES.EDUCATION]: [
    "University acceptance",
    "Student registration",
    "Education enrollment",
    "Academic or training documents",
  ],

  [DOCUMENT_CATEGORIES.BUSINESS]: [
    "Corporate balance sheet",
    "Corporate P&L",
    "Company incorporation",
    "Business ownership documents",
  ],

  [DOCUMENT_CATEGORIES.RESIDENCY_HOUSING]: [
    "Residency registration",
    "Rental agreement",
    "Protected housing",
    "Address or housing eligibility documents",
  ],

  [DOCUMENT_CATEGORIES.FAMILY_LEGAL]: [
    "Birth certificate",
    "Marriage certificate",
    "Civil partnership documents",
    "Divorce documents",
    "Family book",
    "Power of attorney",
    "Court/legal family documents",
  ],

  [DOCUMENT_CATEGORIES.BENEFITS_PENSION]: [
    "Pension certificate",
    "Benefits certificate",
    "Revalorization certificate",
    "Unemployment certificate",
    "Public benefit certificates",
  ],

  [DOCUMENT_CATEGORIES.PAYMENT_RECEIPT]: [
    "Proof of payment",
    "Transfer receipt",
    "Bank transfer payment receipt",
  ],

  [DOCUMENT_CATEGORIES.FINANCIAL]: [
    "Bank statement",
    "Generic financial record",
    "Investment documents",
    "Loan documents",
    "Account documents",
  ],

  [DOCUMENT_CATEGORIES.MEDICAL_DISABILITY]: [
    "Disability certificate",
    "Medical certificate",
    "Health-related proof",
  ],

  [DOCUMENT_CATEGORIES.OTHER]: [
    "Unknown",
    "Uncategorized document",
    "Documents not fitting other categories",
  ],
};

const DOCUMENT_CATEGORY_ENUM = Object.values(DOCUMENT_CATEGORIES);

module.exports = {
  DOCUMENT_CATEGORIES,
  DOCUMENT_CATEGORY_CONFIG,
  DOCUMENT_CATEGORY_ENUM,
};
